// Mesure du parcours : ce que fait le visiteur et où il s'arrête (mode d'emploi : docs/MESURE.md).
// Aucun texte saisi n'est transmis : uniquement des noms d'événements et des libellés fixes.
(() => {
  const track = (name, data, detail) => { if (typeof window.adcTrack === 'function') window.adcTrack(name, data || {}, detail); };
  const tag = (key, value) => { if (typeof window.adcTag === 'function') window.adcTag(key, value); };
  const store = {
    get(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del(k) { try { sessionStorage.removeItem(k); } catch (e) {} },
  };
  const G = window.adcGarment || null;
  const page = (window.adcMesure && window.adcMesure.page) || '';
  const FORM = '[data-adc-visual-form]';
  const CONTACT = '.adc-contact-form';

  // Étiquettes de session : type de page, arrivée par le lien du mail ou non.
  if (page) tag('page', page);
  tag('origine', G && G.fromLink() ? 'lien_mail' : 'direct');

  // Sections vues, une fois chacune : montre jusqu'où les visiteurs descendent.
  const main = document.getElementById('MainContent');
  if (main && 'IntersectionObserver' in window) {
    const seen = new Set();
    const keyOf = (el) => el.dataset.adcSection || (el.id.split('__')[1] || '').replace(/[^a-z0-9_-]/gi, '');
    const onSeen = (entries, obs) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      obs.unobserve(en.target);
      const k = keyOf(en.target);
      if (!k || seen.has(k)) return;
      seen.add(k);
      track('section_vue', { page, section: k }, k);
    });
    // Une section compte quand son haut a dépassé le tiers bas de l'écran ; le pied de page, dès qu'il apparaît.
    const io = new IntersectionObserver(onSeen, { rootMargin: '0px 0px -35% 0px' });
    const ioFoot = new IntersectionObserver(onSeen);
    main.querySelectorAll(':scope > .shopify-section').forEach((el) => {
      if (el.id.indexOf('__') > -1 && el.offsetHeight > 0) io.observe(el);
    });
    const footer = document.querySelector('.adc-footer');
    if (footer) { footer.dataset.adcSection = 'pied_de_page'; ioFoot.observe(footer); }
  }

  // Clics : question ouverte, tenue ouverte, envoi tenté.
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const summary = t.closest('.adc-faq summary');
    if (summary) {
      // Identifiant stable de la question (clé du bloc dans le gabarit), préfixé par la page hors accueil.
      const details = summary.parentElement;
      const rank = Array.from(document.querySelectorAll('.adc-faq details')).indexOf(details) + 1;
      const id = (page === 'index' ? '' : page + '_') + (details.dataset.adcQ || ('q' + rank));
      setTimeout(() => { if (details.open) track('faq_ouverte', { page, question: id, rang: rank }, id); }, 0);
      return;
    }
    const card = t.closest('.adc-product-card [data-adc-card-link], a.adc-product-card');
    if (card) {
      const handle = (card.getAttribute('href') || '').split('?')[0].split('#')[0].split('/').filter(Boolean).pop() || '';
      track('tenue_ouverte', { page, produit: handle }, handle);
      return;
    }
    if (t.closest(FORM + ' [type="submit"]')) track('envoi_tente', { page });
  });

  // Blocage : le premier champ que le navigateur refuse au moment de l'envoi (celui qu'il montre au visiteur).
  const fieldKey = (f) => {
    const n = f.getAttribute('name') || '';
    if (/Nom/.test(n)) return 'nom';
    if (/email/i.test(n) || f.type === 'email') return 'email';
    if (/phone/i.test(n) || f.type === 'tel') return 'telephone';
    if (/body/i.test(n)) return 'message';
    return 'autre';
  };
  const formKey = (form) => {
    if (form.matches(FORM)) return 'maquette';
    if (form.matches(CONTACT)) return 'contact';
    return 'autre';
  };
  let blockTick = false;
  const lastAt = {};
  document.addEventListener('invalid', (e) => {
    const f = e.target;
    if (!f || !f.form || blockTick) return;
    // Le navigateur signale tous les champs invalides d'un coup : seul le premier est compté.
    blockTick = true;
    setTimeout(() => { blockTick = false; }, 0);
    const fk = formKey(f.form), k = fieldKey(f), sig = fk + '_' + k, now = Date.now();
    if (now - (lastAt[sig] || 0) < 1500) return;
    lastAt[sig] = now;
    track('envoi_bloque', { page, formulaire: fk, champ: k, motif: f.validity && f.validity.valueMissing ? 'vide' : 'format' }, sig);
  }, true);

  // Entonnoir de la demande de maquette sur l'accueil : cinq étapes, chacune comptée une fois par page.
  const hero = document.querySelector('[data-adc-herolive]');
  const heroOpen = () => !!(hero && hero.querySelector(FORM + ' [type="submit"]'));
  const done = {};
  const step = (name) => { if (done[name]) return; done[name] = true; track('etape_' + name, { page }); };
  const hasName = () => !!(G && (G.state.name || G.state.logo));
  let emailSeen = false;
  const arrive = () => {
    if (!heroOpen()) return;
    step('1_arrivee');
    if (hasName()) step('2_nom');
  };
  arrive();
  if (heroOpen()) {
    document.addEventListener('adc:nom', () => { if (hasName()) step('2_nom'); });
    document.addEventListener('adc:logo', () => { if (hasName()) step('2_nom'); });
  }
  document.addEventListener('input', (e) => {
    const f = e.target;
    if (emailSeen || !f || !f.matches || !f.matches(FORM + ' input[type="email"]')) return;
    emailSeen = true;
    track('email_saisi', { page });
    if (hero && hero.contains(f)) step('3_email');
  }, true);
  // L'envoi n'arrive ici (phase de remontée) que s'il n'est pas retenu par le téléversement du logo.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.matches) return;
    if (form.matches(CONTACT)) { store.set('adc_envoi_contact', '1'); return; }
    if (!form.matches(FORM)) return;
    const onHero = !!(hero && hero.contains(form));
    store.set('adc_envoi', onHero ? 'accueil' : 'autre');
    // Un envoi valide suppose un nom (ou un logo) et un email : les étapes non vues sont rattrapées.
    if (onHero) { step('2_nom'); step('3_email'); step('4_envoi'); }
  });
  // Page restaurée par le navigateur (retour arrière) : elle compte comme une nouvelle page.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    Object.keys(done).forEach((k) => { delete done[k]; });
    emailSeen = false;
    arrive();
  });

  // Retour d'envoi : confirmation ou erreur, comptées une seule fois (pas à chaque rechargement).
  const sent = store.get('adc_envoi');
  if (sent) {
    const ok = document.querySelector('.adc-herolive__done, ' + FORM + ' .adc-status[role="status"]');
    const ko = document.querySelector(FORM + ' .adc-status--error');
    if (ok) {
      store.del('adc_envoi');
      track('demande_envoyee', { page });
      tag('demande', 'envoyee');
      if (sent === 'accueil') track('etape_5_confirmation', { page });
    } else if (ko) {
      store.del('adc_envoi');
      track('demande_erreur', { page });
    }
  }
  if (store.get('adc_envoi_contact')) {
    const ok = document.querySelector(CONTACT + ' .adc-status[role="status"]');
    const ko = document.querySelector(CONTACT + ' .adc-status--error');
    if (ok || ko) {
      store.del('adc_envoi_contact');
      track(ok ? 'contact_envoye' : 'contact_erreur', { page });
    }
  }
})();
